import { type ProjectCode } from '@constants'
import { type ValueOf } from '@dni-types/utilities/value-of'
import { type BaseAnalyticsEvent } from './base/base-event'
import { type RemoveFromCartEvent, type AddToCartEvent, type PurchaseEvent, type BeginCheckoutEvent, type ViewItemListEvent, type ViewItemEvent, type PageViewEvent } from './base/ga4-events'

export interface FastpassPageViewEvent extends PageViewEvent {
  eventName: 'page_view'
  eventParams: PageViewEvent['eventParams'] & {
    campaign_code: string
  }
}

export interface FastpassAddToCartEvent extends AddToCartEvent {
  eventName: 'add_to_cart'
  eventParams: AddToCartEvent['eventParams'] & {
    campaign_code: string
  }
}

export interface FastpassRemoveFromCartEvent extends RemoveFromCartEvent {
  eventName: 'remove_from_cart'
  eventParams: RemoveFromCartEvent['eventParams'] & {
    campaign_code: string
  }
}

export interface FastpassPurchaseEvent extends PurchaseEvent {
  eventName: 'purchase'
  eventParams: PurchaseEvent['eventParams'] & {
    campaign_code: string
  }
}

export interface FastpassMerchantPurchaseEvent extends Omit<PurchaseEvent, 'eventName'> {
  eventName: 'merchant_purchase'
  eventParams: PurchaseEvent['eventParams'] & {
    campaign_code: string
  }
}

export interface FastpassCampaignPurchaseEvent extends Omit<PurchaseEvent, 'eventName'> {
  eventName: 'campaign_purchase'
  eventParams: PurchaseEvent['eventParams'] & {
    campaign_code: string
  }
}

export interface FastpassBeginCheckoutEvent extends BeginCheckoutEvent {
  eventName: 'begin_checkout'
  eventParams: BeginCheckoutEvent['eventParams'] & {
    campaign_code: string
  }
}

export interface FastpassViewItemEvent extends ViewItemEvent {
  eventName: 'view_item'
  eventParams: ViewItemEvent['eventParams'] & {
    campaign_code: string
  }
}

export interface FastpassViewItemListEvent extends ViewItemListEvent {
  eventName: 'view_item_list'
  eventParams: ViewItemListEvent['eventParams'] & {
    campaign_code: string
  }
}
/** 跨品牌專站 (STM) 頁面瀏覽 */
export const StmSectionName = {
  BRAND_PROMO: 'brand_promo',
  NEW_ARRIVALS: 'new_arrivals',
  HOT_SELLING: 'hot_selling',
} as const

export type StmSectionNameType = ValueOf<typeof StmSectionName>

export interface CrossBrandBannerClickEvent extends BaseAnalyticsEvent {
  eventName: 'cross_brand_banner_click'
  eventParams: {
    event_category: 'cross_brand_banner_click'
    banner_id: number
    banner_position: number
    destination_url: string
  }
}

export interface BrandNavClickEvent extends BaseAnalyticsEvent {
  eventName: 'brand_nav_click'
  eventParams: {
    event_category: 'brand_nav_click'
    project_code: ProjectCode
    user_id: string
  }
}

export interface StmPageViewEvent extends BaseAnalyticsEvent {
  eventName: 'stm_page_view'
  eventParams: {
    event_category: 'page_view'
    project_code: ProjectCode
    user_id: string
  }
}
export interface StmAddToCartEvent extends BaseAnalyticsEvent {
  eventName: 'stm_add_to_cart'
  eventParams: {
    event_category: 'add_to_cart'
    section_name: StmSectionNameType
    project_code: ProjectCode
    user_id: string
  }
}


export interface StmPurchaseEvent extends BaseAnalyticsEvent {
  eventName: 'stm_purchase'
  eventParams: {
    event_category: 'purchase'
    project_code: ProjectCode
    user_id: string
  }
}


export type FastpassGa4Events =
  | FastpassPageViewEvent
  | FastpassAddToCartEvent
  | FastpassRemoveFromCartEvent
  | FastpassPurchaseEvent
  | FastpassMerchantPurchaseEvent
  | FastpassCampaignPurchaseEvent
  | FastpassBeginCheckoutEvent
  | FastpassViewItemEvent
  | FastpassViewItemListEvent
  | CrossBrandBannerClickEvent
  | BrandNavClickEvent
  | StmPageViewEvent
  | StmPurchaseEvent
  | StmAddToCartEvent
